import React, { Component } from 'react';
import { removeClass, addClass, hasClass } from '../helpers';
import { connect } from 'react-redux';
import {
  switchLanguage,
  fetchCategories,
  updateSearchKeyword,
  fetchTechMessage,
  channelsFetchData,
  fetchProfiles,
  setProfile,
  signOutUser,
  searchResultsRequest,
} from '../actions';
import translate from './TranslateHOC';
import { touchClass, setTheme, getTheme } from '../helpers';
import * as c from '../constants';
import TechnicalError from './alerts/TechnicalError';
import { default as HeaderV2 } from '../v2/components/header/Header';
import IsLoadingAnim from './alerts/IsLoadingAnim';
import { bindActionCreators } from 'redux';
import { show } from 'redux-modal';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFloatingToggle: 'hide',
      showMobileNav: false,
      navOffset: 0,
      navActive: '',
      navHeight: 72,
      showSubNav: false,
    };
  }

  componentDidMount = () => {
    this.props.fetchCats(this.props.curLang);
    this.props.fetchChannels();
    this.props.fetchProfiles();
    touchClass();
    setTheme(getTheme());
    this.props.fetchTechMessage(this.props.curLang);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.curLang !== this.props.curLang) {
      this.props.fetchCats(nextProps.curLang);
      this.props.fetchTechMessage(nextProps.curLang);
      this.props.fetchChannels();
    }
  };

  componentDidUpdate = () => {
    this.checkNavClass();
  };

  changeLang = () => {
    this.props.switchLang(this.props.curLang);
    this.closeMobNav();
  };

  roundNum(value, step) {
    step || (step = 1.0);
    var inv = 1.0 / step;
    return Math.round(value * inv) / inv;
  }
  handleMobileSubmit = (keyword) => {
    if (this.props.location.pathname === '/search') {
      this.props.updateSearchKeyword(keyword);
    }
    this.handleSearchSubmit(keyword);
  };
  handleSearchSubmit = (keyword) => {
    // submits search keywords to the search page
    if (this.state.showMobileNav) this.closeMobNav();
    this.props.history.push('/search?s=' + keyword);
  };

  closeMobNav = (event) => {
    // close mobile nav
    this.setState({ showMobileNav: false });
    this.setState({ showSubNav: false });
    window.scrollTo(0, 0);
  };

  checkNavClass = () => {
    const rootEl = document.getElementById('root');
    const thisClass = 'show-mobile-nav';

    if (this.state.showMobileNav) {
      if (!hasClass(rootEl, thisClass)) {
        addClass(rootEl, thisClass);
      }
    } else {
      if (hasClass(rootEl, thisClass)) {
        removeClass(rootEl, thisClass);
      }
    }
  };

  handleToggle = (e) => {
    this.setState({ showSubNav: !this.state.showSubNav });
  };

  signOut = () => {
    this.props.signOutUser();
  };

  handleOpen = (name) => () => {
    const trans = this.props.strings;
    this.props.show(c.CONFIRM_DIALOG, {
      message: trans.confirmSignOut,
      confirmLbl: trans.signOut,
      cancelLbl: trans.cancel,
      handleSubmit: this.signOut,
    });
  };

  submitSearchRequest = (_searchKeyword) => {
    this.props.getSearchResults(_searchKeyword.trim());
  };

  render() {
    const {
      strings,
      auth,
      techMessage,
      techMessageError,
      channels,
      channelsIsLoading,
      channelsHasErrored,
      profileId,
    } = this.props;
    const genres = this.props.categories.categories;
    const profilesData = this.props.profilesData.profiles;

    let currentProfileImg;
    let currentProfile = {};

    if (channelsIsLoading) {
      return <IsLoadingAnim />;
    }

    if (channelsHasErrored) {
      return (
        <div className="header-outer">
          <div className="alert alert--error loading-error">
            {strings.sorryLoading}
          </div>
        </div>
      );
    }

    if (profilesData) {
      currentProfile = profilesData.find(function (obj) {
        return parseInt(obj.id, 10) === parseInt(profileId, 10);
      });
      if (currentProfile) {
        currentProfileImg =
          window.AVATAR_IMG_PATH + currentProfile.avatar_filename;
      }
    } else {
      currentProfileImg = window.AVATAR_IMG_PATH + c.DEFAULT_PROFILE_IMG;
    }

    if (techMessage && !techMessageError && techMessage.error) {
      document.body.classList.add('tech-message');
    }

    return (
      <div className="header-outer">
        {techMessage && !techMessageError && techMessage.error && (
          <TechnicalError errorMessage={techMessage} />
        )}
        <HeaderV2
          className="header"
          strings={strings}
          location={this.props.location}
          history={this.props.history}
          updateSearchKeyword={this.props.updateSearchKeyword}
          changeLang={this.changeLang.bind(this)}
          channels={channels}
          categories={this.props.categories}
          genres={genres}
          auth={auth}
          currentProfileImg={currentProfileImg}
          profileId={profileId}
          profileData={profilesData}
          currentPath={this.props.location.pathname}
          setProfile={this.props.setProfile}
          signOutUser={this.handleOpen(c.CONFIRM_SIGN_OUT_DIALOG)}
          searchKeyword={this.props.searchKeyword}
          submitSearchRequest={this.submitSearchRequest}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    curLang: state.curLang,
    categories: state.categories.success,
    auth: state.auth.authenticated,
    techMessage: state.techMessage.success,
    techMessageError: state.techMessage.error,
    channels: state.channels.success,
    channelsIsLoading: state.channels.loading,
    channelsHasErrored: state.channels.error,
    profilesData: state.profilesData.success,
    profileName: state.profileName,
    profileId: state.profileId,
    searchKeyword: state.searchKeyword.success,
    searchResults: state.searchResults.success,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    switchLang: (lang) => dispatch(switchLanguage(lang)),
    fetchCats: (lang) => dispatch(fetchCategories(lang)),
    getSearchResults: (keywords) => dispatch(searchResultsRequest(keywords)),
    updateSearchKeyword: (lang) => dispatch(updateSearchKeyword(lang)),
    fetchTechMessage: (lang) => dispatch(fetchTechMessage(lang)),
    fetchChannels: () => dispatch(channelsFetchData()),
    fetchProfiles: (lang) => dispatch(fetchProfiles(lang)),
    setProfile: (lang, id) => dispatch(setProfile(lang, id)),
    signOutUser: () => dispatch(signOutUser()),
    show: bindActionCreators(show, dispatch),
  };
};

export default translate(connect(mapStateToProps, mapDispatchToProps)(Header));
